import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import { compose } from "recompose";
import { Paper, IconButton } from '@material-ui/core';
import {
    Map as MapIcon,
    Satellite as SatelliteIcon
} from '@material-ui/icons';

const useStyles = makeStyles({
  mapTypeIconButton: {
    backgroundColor: '#ffffff',
    fontSize: 14,
    "&:hover": {
      backgroundColor: '#efefef',
    }
  }
});

function MapTypeManager({ mapReady, mapRef, isMobile }) {
  const classes = useStyles();      
  const [iconMode, setIconMode] = useState("default");

  function onToggleMapType() {    
    if (mapRef.current.mapTypeId === "hybrid") {
        setIconMode("default");
        mapRef.current.setMapTypeId('default');
    } else {
        setIconMode("satellite");
        mapRef.current.setMapTypeId('hybrid');            
    }
  }

  if (!mapReady || !isMobile) return null;
  return (
      <Paper style={{ position: 'absolute', bottom: 50, margin: 10 }}>    
        <IconButton className={classes.mapTypeIconButton} onClick={onToggleMapType}>    
        {
            iconMode === "satellite"
            ?
            <SatelliteIcon fontSize="inherit" />
            :
            <MapIcon fontSize="inherit" />
        }  
        </IconButton>
      </Paper>    
  )
}

function mapState({ exploreMap, appState }) {
  return {
    mapReady: exploreMap.bounds !== null && exploreMap.bounds !== undefined,
    isMobile: appState.isMobile,
  };
}

const mapDispatch = {
  
}

export default compose(
    connect(mapState, mapDispatch)
)(MapTypeManager);
